@@ -0,0 +1,42 @@
<template>
  <label
    v-for="(item, index) in inputData"
    :key="index"
    class="relative min-h-24px flex cursor-pointer select-none items-center px-4px title-12-h16-m text-primary-80"
    :class="{
      'cursor-not-allowed !text-primary-30': item.isDisable,
    }"
  >
    <input
      :checked="modelValue === item.key"
      class="mr-8px disabled:border-primary-30"
      :disabled="item.isDisable ?? false"
      :name="name"
      type="radio"
      :value="item.key"
      @change="$emit('update:modelValue', item.key)"
    />
    {{ item.title }}
  </label>
</template>

<script setup lang="ts">
import { type InputRadioData } from '@/components/InputRadio.type'

defineProps<{
  inputData: InputRadioData[]
  modelValue: string
  name: string
}>()

defineEmits<{
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'update:modelValue': [value: string]
}>()
</script>
